function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-add",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#30D7E5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M11.647 5.5l-.09.008c-.233.042-.41.247-.41.492v5.147H6c-.276 0-.5.224-.5.5v1.412l.008.09c.042.233.247.41.492.41l5.147-.001v5.148c0 .276.224.5.5.5h1.412l.09-.008c.233-.043.41-.247.41-.492l-.001-5.148h5.148c.276 0 .5-.223.5-.5v-1.41l-.008-.09c-.043-.234-.247-.41-.492-.41l-5.148-.001V6c0-.276-.223-.5-.5-.5h-1.41z"
})));

var _ref3 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-arrow",
  viewBox: "0 0 78 37"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.404 27.807l-.35 1.968c37.033 6.607 65.559-9.552 74.592-28.93L74.834 0C66.207 18.495 38.992 33.924 3.482 27.992l-1.078-.185z",
  transform: "translate(.55 .5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 28.222L7.825 35.859 9.502 34.144 4.057 28.823 11.133 25.159 10.03 23.027z",
  transform: "translate(.55 .5)"
})));

var _ref4 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-calculator-large",
  viewBox: "0 0 91 95"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "prefix__a",
  width: "123.1%",
  height: "122.1%",
  x: "-11.5%",
  y: "-11.1%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.177201705 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#prefix__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 45.6,
  cy: 70.8,
  r: 1.2,
  fill: "#CDCDCD"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45.6,
  cy: 76.8,
  r: 1.2,
  fill: "#CDCDCD"
}), /*#__PURE__*/React.createElement("rect", {
  width: 90.6,
  height: 94.8,
  fill: "#FFF",
  rx: 9.6
}), /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 21.6,
  x: 9.6,
  y: 9.6,
  fill: "#30D7E5",
  rx: 1.2
}), /*#__PURE__*/React.createElement("rect", {
  width: 21.6,
  height: 21.6,
  x: 9.6,
  y: 36.6,
  fill: "#F2F8FA",
  rx: 1.2
}), /*#__PURE__*/React.createElement("rect", {
  width: 21.6,
  height: 21.6,
  x: 9.6,
  y: 62.4,
  fill: "#F2F8FA",
  rx: 1.2
}), /*#__PURE__*/React.createElement("rect", {
  width: 21.6,
  height: 21.6,
  x: 34.8,
  y: 36.6,
  fill: "#F2F8FA",
  rx: 1.2
}), /*#__PURE__*/React.createElement("rect", {
  width: 21.6,
  height: 47.4,
  x: 60,
  y: 36.6,
  fill: "#F2F8FA",
  rx: 1.2
}), /*#__PURE__*/React.createElement("rect", {
  width: 21.6,
  height: 21.6,
  x: 34.8,
  y: 62.4,
  fill: "#F2F8FA",
  rx: 1.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "nonzero",
  d: "M59.68 24.515c.097 0 .175-.032.235-.098.06-.065.093-.135.1-.212l.06-.735c.373-.027.705-.105.995-.235.29-.13.534-.3.733-.508.198-.208.349-.448.452-.72.103-.271.155-.562.155-.872 0-.313-.058-.574-.175-.783-.117-.208-.27-.382-.457-.522-.189-.14-.4-.254-.636-.342-.235-.089-.472-.17-.712-.243l.175-2.07c.13.03.248.068.355.115.107.047.204.093.292.137.089.046.167.084.235.116.069.031.128.047.178.047.067 0 .123-.017.17-.05.047-.033.093-.083.14-.15l.3-.455c-.19-.18-.413-.342-.67-.485-.257-.143-.562-.243-.915-.3l.085-.985h-.455c-.097 0-.175.032-.235.095s-.093.135-.1.215l-.055.63c-.367.017-.692.087-.975.21-.283.123-.522.28-.715.47-.193.19-.34.406-.443.648-.101.241-.152.489-.152.742 0 .34.057.623.17.85.113.227.263.414.448.563.184.148.393.267.625.357.231.09.465.168.702.235l-.19 2.24c-.187-.033-.348-.085-.485-.155-.137-.07-.258-.14-.365-.21-.107-.07-.202-.13-.285-.183-.083-.051-.162-.077-.235-.077-.06 0-.117.016-.172.047-.055.032-.1.073-.133.123l-.38.565c.24.237.53.435.873.595.341.16.707.267 1.097.32l-.09 1.07h.455zm.005-5.51c-.127-.047-.243-.1-.35-.157-.107-.059-.2-.125-.278-.2-.078-.075-.139-.161-.182-.258-.043-.097-.065-.208-.065-.335 0-.11.02-.214.057-.313.039-.098.1-.187.183-.267.083-.08.19-.148.32-.203.13-.054.287-.094.47-.117l-.155 1.85zm.48 3.43l.17-2.03c.13.043.25.092.36.145.11.053.206.117.288.19.081.073.145.158.19.253.044.095.067.205.067.332 0 .31-.09.56-.273.753-.181.191-.449.31-.802.357zm5.515 2.08c.097 0 .175-.032.235-.098.06-.065.093-.135.1-.212l.06-.735c.373-.027.705-.105.995-.235.29-.13.534-.3.733-.508.198-.208.349-.448.452-.72.103-.271.155-.562.155-.872 0-.313-.058-.574-.175-.783-.117-.208-.27-.382-.457-.522-.189-.14-.4-.254-.636-.342-.234-.089-.472-.17-.712-.243l.175-2.07c.13.03.248.068.355.115.107.047.204.093.293.137.088.046.166.084.234.116.069.031.128.047.178.047.067 0 .123-.017.17-.05.047-.033.093-.083.14-.15l.3-.455c-.19-.18-.413-.342-.67-.485-.257-.143-.562-.243-.915-.3l.085-.985h-.455c-.097 0-.175.032-.235.095s-.093.135-.1.215l-.055.63c-.367.017-.692.087-.975.21-.283.123-.522.28-.715.47-.193.19-.34.406-.442.648-.102.241-.153.489-.153.742 0 .34.057.623.17.85.113.227.263.414.448.563.184.148.393.267.624.357.232.09.466.168.703.235l-.19 2.24c-.187-.033-.348-.085-.485-.155-.137-.07-.258-.14-.365-.21-.107-.07-.202-.13-.285-.183-.083-.051-.162-.077-.235-.077-.06 0-.117.016-.172.047-.055.032-.1.073-.133.123l-.38.565c.24.237.53.435.873.595.341.16.707.267 1.097.32l-.09 1.07h.455zm.005-5.51c-.127-.047-.243-.1-.35-.157-.107-.059-.2-.125-.277-.2-.079-.075-.14-.161-.183-.258-.043-.097-.065-.208-.065-.335 0-.11.02-.214.058-.313.038-.098.099-.187.182-.267.083-.08.19-.148.32-.203.13-.054.287-.094.47-.117l-.155 1.85zm.48 3.43l.17-2.03c.13.043.25.092.36.145.11.053.206.117.288.19.081.073.144.158.19.253.044.095.067.205.067.332 0 .31-.09.56-.272.753-.182.191-.45.31-.803.357zm5.515 2.08c.097 0 .175-.032.235-.098.06-.065.093-.135.1-.212l.06-.735c.373-.027.705-.105.995-.235.29-.13.534-.3.733-.508.198-.208.349-.448.452-.72.103-.271.155-.562.155-.872 0-.313-.058-.574-.175-.783-.117-.208-.27-.382-.457-.522-.189-.14-.4-.254-.636-.342-.234-.089-.472-.17-.712-.243l.175-2.07c.13.03.248.068.355.115.107.047.204.093.293.137.088.046.166.084.234.116.069.031.128.047.178.047.067 0 .123-.017.17-.05.047-.033.093-.083.14-.15l.3-.455c-.19-.18-.413-.342-.67-.485-.257-.143-.562-.243-.915-.3l.085-.985h-.455c-.097 0-.175.032-.235.095s-.093.135-.1.215l-.055.63c-.367.017-.692.087-.975.21-.283.123-.522.28-.715.47-.193.19-.34.406-.442.648-.102.241-.153.489-.153.742 0 .34.057.623.17.85.113.227.263.414.448.563.184.148.393.267.624.357.232.09.466.168.703.235l-.19 2.24c-.187-.033-.348-.085-.485-.155-.137-.07-.258-.14-.365-.21-.107-.07-.202-.13-.285-.183-.083-.051-.162-.077-.235-.077-.06 0-.118.016-.172.047-.056.032-.1.073-.133.123l-.38.565c.24.237.53.435.873.595.341.16.707.267 1.097.32l-.09 1.07h.455zm.005-5.51c-.127-.047-.243-.1-.35-.157-.107-.059-.2-.125-.277-.2-.079-.075-.14-.161-.183-.258-.043-.097-.065-.208-.065-.335 0-.11.02-.214.058-.313.038-.098.099-.187.182-.267.083-.08.19-.148.32-.203.13-.054.287-.094.47-.117l-.155 1.85zm.48 3.43l.17-2.03c.13.043.25.092.36.145.11.053.206.117.288.19.081.073.144.158.19.253.044.095.067.205.067.332 0 .31-.09.56-.272.753-.182.191-.45.31-.803.357zM17.188 71.164l-.043.054c-.072.116-.058.27.043.37l2.091 2.092-2.091 2.092c-.117.117-.117.307 0 .424l.576.576.054.043c.116.072.27.058.37-.043l2.092-2.091 2.092 2.091c.117.117.307.117.424 0l.576-.576.043-.054c.072-.116.058-.27-.043-.37l-2.091-2.092 2.091-2.092c.117-.117.117-.307 0-.424l-.576-.576-.054-.043c-.116-.072-.27-.058-.37.043l-2.092 2.091-2.092-2.091c-.117-.117-.307-.117-.424 0l-.576.576zM19.873 43.314l-.07.008c-.132.031-.23.15-.23.292l-.001 2.958h-2.958c-.165 0-.3.135-.3.3v.815l.008.07c.031.132.15.23.292.23h2.958v2.959c0 .165.135.3.3.3h.815l.07-.008c.132-.031.23-.15.23-.292v-2.959h2.959c.165 0 .3-.134.3-.3v-.814l-.008-.07c-.031-.132-.15-.23-.292-.23l-2.959-.001v-2.958c0-.165-.134-.3-.3-.3h-.814z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  stroke: "#333",
  strokeWidth: 0.6,
  d: "M49.2 47.7H42c-.083 0-.158-.034-.212-.088-.054-.054-.088-.13-.088-.212v-.6l7.5-.3c.083 0 .158.034.212.088.054.054.088.13.088.212v.6c0 .083-.034.158-.088.212-.054.054-.13.088-.212.088zM74.4 59.1h-7.2c-.083 0-.158-.034-.212-.088-.054-.054-.088-.13-.088-.212v-.6l7.5-.3c.083 0 .158.034.212.088.054.054.088.13.088.212v.6c0 .083-.034.158-.088.212-.054.054-.13.088-.212.088zM74.4 63.3h-7.2c-.083 0-.158-.034-.212-.088-.054-.054-.088-.13-.088-.212v-.6l7.5-.3c.083 0 .158.034.212.088.054.054.088.13.088.212v.6c0 .083-.034.158-.088.212-.054.054-.13.088-.212.088zM50.129 74.1H42.07l-.355-.844c.157-.256.24-.356.355-.356h8.058l.355.844c-.157.256-.24.356-.355.356z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 70,
  r: 1,
  fill: "#333",
  stroke: "#333"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 77,
  r: 1,
  fill: "#333",
  stroke: "#333"
})));

var _ref5 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-calculator-small",
  viewBox: "0 0 20 20"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "prefix__b",
  width: "205%",
  height: "214.8%",
  x: "-52.5%",
  y: "-55%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.177201705 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#prefix__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10.022,
  cy: 14.146,
  r: 1,
  fill: "#CDCDCD"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10.022,
  cy: 15.345,
  r: 1,
  fill: "#CDCDCD"
}), /*#__PURE__*/React.createElement("rect", {
  width: 19.912,
  height: 18.941,
  fill: "#FFF",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 15.824,
  height: 4.316,
  x: 2.11,
  y: 1.918,
  fill: "#30D7E5",
  rx: 1.2
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.747,
  height: 4.316,
  x: 2.11,
  y: 7.313,
  fill: "#F2F8FA",
  rx: 1.2
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.747,
  height: 4.316,
  x: 2.11,
  y: 12.468,
  fill: "#F2F8FA",
  rx: 1.2
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.747,
  height: 4.316,
  x: 7.648,
  y: 7.313,
  fill: "#F2F8FA",
  rx: 1.2
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.747,
  height: 9.471,
  x: 13.187,
  y: 7.313,
  fill: "#F2F8FA",
  rx: 1.2
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.747,
  height: 4.316,
  x: 7.648,
  y: 12.468,
  fill: "#F2F8FA",
  rx: 1.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "nonzero",
  d: "M13.116 4.898c.022 0 .039-.006.052-.02.013-.012.02-.027.022-.042l.013-.147c.082-.005.155-.02.219-.047.064-.026.117-.06.161-.101.044-.042.077-.09.1-.144.022-.054.033-.112.033-.174 0-.063-.012-.115-.038-.157-.026-.041-.06-.076-.1-.104-.042-.028-.088-.05-.14-.068-.052-.018-.104-.034-.157-.049l.039-.413c.028.006.054.013.078.023l.064.027.052.023c.015.006.028.01.039.01.014 0 .027-.004.037-.01.01-.007.02-.017.03-.03l.067-.091c-.042-.036-.091-.069-.147-.097-.057-.029-.124-.049-.202-.06l.02-.197h-.1c-.022 0-.04.006-.053.019-.013.013-.02.027-.021.043l-.013.126c-.08.003-.152.017-.214.042-.062.024-.115.056-.157.094-.042.038-.075.08-.097.129-.023.048-.034.098-.034.148 0 .068.013.125.038.17.025.045.057.083.098.113.04.03.086.053.137.071.051.018.103.034.155.047l-.042.448c-.041-.007-.077-.017-.107-.031-.03-.014-.056-.028-.08-.042l-.063-.037c-.018-.01-.035-.015-.051-.015-.013 0-.026.003-.038.01-.012.005-.022.014-.03.024l-.083.112c.053.048.117.087.192.12.075.031.156.053.241.063l-.02.214h.1zm.002-1.1c-.028-.01-.054-.02-.077-.032-.024-.012-.044-.025-.061-.04-.018-.015-.03-.032-.04-.052-.01-.019-.015-.041-.015-.067 0-.022.004-.042.013-.062.008-.02.022-.038.04-.053.018-.016.042-.03.07-.041.029-.01.063-.019.104-.023l-.034.37zm.105.685l.037-.406c.029.009.055.018.08.029.024.01.045.023.063.038.018.015.032.031.042.05.01.02.014.041.014.067 0 .062-.02.112-.06.15-.04.038-.098.062-.176.072zm1.212.415c.021 0 .039-.006.052-.02.013-.012.02-.027.022-.042l.013-.147c.082-.005.155-.02.219-.047.063-.026.117-.06.16-.101.044-.042.077-.09.1-.144.023-.054.034-.112.034-.174 0-.063-.013-.115-.038-.157-.026-.041-.06-.076-.1-.104-.042-.028-.089-.05-.14-.068-.052-.018-.104-.034-.157-.049l.038-.413c.029.006.055.013.078.023l.065.027.051.023c.015.006.028.01.04.01.014 0 .027-.004.037-.01.01-.007.02-.017.03-.03l.066-.091c-.041-.036-.09-.069-.147-.097-.056-.029-.123-.049-.2-.06l.018-.197h-.1c-.021 0-.039.006-.052.019-.013.013-.02.027-.022.043l-.012.126c-.08.003-.152.017-.214.042-.062.024-.115.056-.157.094-.043.038-.075.08-.098.129-.022.048-.033.098-.033.148 0 .068.012.125.037.17.025.045.058.083.099.113.04.03.086.053.137.071.05.018.102.034.154.047l-.041.448c-.041-.007-.077-.017-.107-.031-.03-.014-.057-.028-.08-.042l-.063-.037c-.018-.01-.035-.015-.051-.015-.014 0-.026.003-.038.01-.012.005-.022.014-.03.024l-.083.112c.053.048.117.087.192.12.075.031.155.053.24.063l-.019.214h.1zm.001-1.1c-.028-.01-.053-.02-.077-.032-.023-.012-.043-.025-.06-.04-.018-.015-.031-.032-.04-.052-.01-.019-.015-.041-.015-.067 0-.022.004-.042.013-.062.008-.02.021-.038.04-.053.018-.016.041-.03.07-.041.029-.01.063-.019.103-.023l-.034.37zm.106.685l.037-.406c.029.009.055.018.08.029.023.01.044.023.062.038.018.015.032.031.042.05.01.02.015.041.015.067 0 .062-.02.112-.06.15-.04.038-.099.062-.176.072zm1.212.415c.021 0 .038-.006.051-.02.014-.012.021-.027.022-.042l.014-.147c.082-.005.155-.02.218-.047.064-.026.118-.06.161-.101.044-.042.077-.09.1-.144.022-.054.034-.112.034-.174 0-.063-.013-.115-.039-.157-.025-.041-.059-.076-.1-.104-.042-.028-.088-.05-.14-.068-.051-.018-.104-.034-.156-.049l.038-.413c.029.006.055.013.078.023.024.009.045.018.064.027l.052.023c.015.006.028.01.04.01.014 0 .026-.004.036-.01.01-.007.021-.017.031-.03l.066-.091c-.042-.036-.09-.069-.147-.097-.056-.029-.124-.049-.201-.06l.019-.197h-.1c-.022 0-.039.006-.052.019-.013.013-.02.027-.022.043l-.012.126c-.08.003-.152.017-.214.042-.063.024-.115.056-.158.094-.042.038-.075.08-.097.129-.022.048-.033.098-.033.148 0 .068.012.125.037.17.025.045.058.083.098.113.041.03.087.053.138.071.05.018.102.034.154.047l-.042.448c-.04-.007-.076-.017-.106-.031-.03-.014-.057-.028-.08-.042l-.063-.037c-.018-.01-.036-.015-.052-.015-.013 0-.026.003-.038.01-.012.005-.021.014-.029.024l-.083.112c.052.048.116.087.191.12.076.031.156.053.242.063l-.02.214h.1zm0-1.1c-.027-.01-.053-.02-.076-.032s-.044-.025-.061-.04-.03-.032-.04-.052c-.01-.019-.014-.041-.014-.067 0-.022.004-.042.012-.062.009-.02.022-.038.04-.053.019-.016.042-.03.07-.041.03-.01.064-.019.104-.023l-.034.37zm.106.685l.038-.406c.028.009.055.018.079.029.024.01.045.023.063.038.018.015.032.031.042.05.01.02.015.041.015.067 0 .062-.02.112-.06.15-.04.038-.099.062-.177.072zM3.778 14.219l-.01.01c-.016.024-.013.054.01.074l.46.418-.46.418c-.026.024-.026.062 0 .085l.126.115.012.009c.025.014.06.011.081-.009l.46-.418.46.418c.026.023.067.023.093 0l.127-.115.01-.01c.015-.024.012-.055-.01-.075l-.46-.418.46-.418c.025-.023.025-.061 0-.084l-.127-.116-.012-.008c-.025-.014-.059-.012-.081.008l-.46.418-.46-.418c-.025-.023-.067-.023-.093 0l-.126.116zM4.368 8.654l-.015.002c-.03.006-.051.03-.051.058v.591h-.65c-.037 0-.066.027-.066.06v.163l.001.014c.007.026.033.046.065.046h.65v.59c0 .034.03.06.066.06h.194c.029-.007.05-.03.05-.06v-.59h.65c.037 0 .067-.027.067-.06v-.163l-.002-.014c-.007-.026-.033-.046-.064-.046h-.65v-.59c0-.034-.03-.06-.066-.06h-.18z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10.11,
  cy: 13.986,
  r: 1,
  fill: "#333",
  stroke: "#333"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10.11,
  cy: 15.385,
  r: 1,
  fill: "#333",
  stroke: "#333"
})));

var _ref6 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-close",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#30D7E5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  stroke: "#333",
  strokeLinejoin: "round",
  d: "M15.84 7.2L12 11.04 8.16 7.2 7.2 8.16 11.04 12 7.2 15.84 8.16 16.8 12 12.96 15.84 16.8 16.8 15.84 12.96 12 16.8 8.16z"
})));

var _ref7 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-dropdown-arrow",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M14.53 15.495c.384 0 .605.447.379.765l-2.531 3.543c-.187.263-.569.263-.756 0l-2.53-3.543c-.227-.318-.006-.765.377-.765zM11.623 5.197c.187-.263.569-.263.756 0l2.53 3.543c.227.318.006.765-.377.765H9.469c-.383 0-.604-.447-.378-.765z"
}));

var _ref8 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-exclamation",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#E90000"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.333 13.333c-.368 0-.666-.298-.666-.667V6c0-.368.298-.667.666-.667h1.334c.368 0 .666.299.666.667v6.666c0 .369-.298.667-.666.667h-1.334zm0 5.333c-.368 0-.666-.298-.666-.666v-1.333c0-.369.298-.667.666-.667h1.334c.368 0 .666.298.666.667V18c0 .368-.298.666-.666.666h-1.334z"
})));

var _ref9 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-info-white",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M12.667 8h-1.334c-.368 0-.666-.298-.666-.667V6c0-.368.298-.667.666-.667h1.334c.368 0 .666.299.666.667v1.333c0 .369-.298.667-.666.667M12.667 18.666h-1.334c-.368 0-.666-.298-.666-.666v-6.667c0-.368.298-.666.666-.666h1.334c.368 0 .666.298.666.666V18c0 .368-.298.666-.666.666"
})));

var _ref10 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-info",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#30D7E5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M12.667 8h-1.334c-.368 0-.666-.298-.666-.667V6c0-.368.298-.667.666-.667h1.334c.368 0 .666.299.666.667v1.333c0 .369-.298.667-.666.667M12.667 18.666h-1.334c-.368 0-.666-.298-.666-.666v-6.667c0-.368.298-.666.666-.666h1.334c.368 0 .666.298.666.666V18c0 .368-.298.666-.666.666"
})));

var _ref11 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-logo",
  viewBox: "0 0 196 34"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M0.282 0.185L8.229 0.185 8.229 24.89 0.282 24.89z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30D7E5",
  d: "M21.698 18.917c.149-1.583-.224-3.492.227-5.386C23.193 8.21 29.228 5.79 33.783 8.87c1.007.68 1.594.75 2.67-.007 4.873-3.43 11.361-.188 11.864 5.96.246 3.007.043 6.05.069 9.077.006.786-.225 1.152-1.111 1.24-3.156.315-3.299.189-3.348-3.003-.038-2.495.192-4.994-.151-7.487-.205-1.49-.994-2.396-2.468-2.705-1.453-.305-2.58.253-3.5 1.34-.559.66-.564 1.44-.56 2.24.01 2.698-.093 5.4.035 8.092.092 1.94-1.2 1.493-2.238 1.487-1.028-.006-2.344.477-2.254-1.472.122-2.627.046-5.263.024-7.895-.02-2.552-1.163-3.925-3.21-3.922-2.113.002-3.423 1.473-3.456 3.972-.034 2.566-.116 5.138.028 7.697.1 1.789-.946 1.715-2.12 1.629-1.06-.078-2.56.559-2.382-1.541.12-1.438.023-2.894.023-4.655M9.604 1.462c4.217.021 7.28 1.9 8.532 5.242.752 2.01.563 2.24-1.542 2.322-1.386.056-2.336-.075-3.12-1.587-1.181-2.283-6.034-2.504-7.785-.603-1.095 1.19-.754 2.64.942 3.25 1.546.555 3.196.821 4.789 1.255 1.274.347 2.551.697 3.79 1.146 2.478.898 3.95 2.645 4.048 5.3.1 2.706-.988 4.848-3.42 6.23-4.365 2.48-10.692 1.8-13.858-1.524-.492-.517-.958-1.117-1.238-1.764-.434-1-1.225-2.296-.342-3.112.833-.77 2.288-.227 3.47-.247.66-.01.554.586.726.988 1.327 3.106 6.943 4.122 9.357 1.708 1.283-1.284 1.117-2.602-.493-3.557-1.69-1.003-3.668-1.07-5.506-1.593-1.143-.326-2.304-.617-3.408-1.047C2.098 12.917.637 11.134.578 8.492.518 5.822 1.786 3.83 4.22 2.641c1.69-.825 3.502-1.182 5.384-1.179"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M101.058 6.2c-.598 0-1.208.076-1.792-.014-1.47-.227-1.719.43-1.708 1.757.042 5.396-.004 5.396 5.68 4.942 2.128-.17 3.106-1.313 3.048-3.561-.053-2.06-1.092-3.07-3.233-3.12-.665-.016-1.33-.003-1.995-.003m-7.876 7.434c0-3.353.05-6.707-.028-10.059-.026-1.15.35-1.441 1.46-1.414 2.92.07 5.841-.003 8.762.03 4.539.053 7.273 2.681 7.333 6.995.062 4.513-2.692 7.468-7.211 7.673-1.524.07-3.056.072-4.58-.004-1.038-.051-1.394.273-1.345 1.324.082 1.77-.046 3.553.046 5.323.062 1.183-.258 1.608-1.531 1.564-3.596-.125-2.848.296-2.897-2.754-.046-2.892-.01-5.786-.01-8.678"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#30D7E5",
  d: "M59.42 21.27c2.515-.009 4.506-2.14 4.472-4.79-.033-2.543-2.209-4.793-4.594-4.747-2.325.045-4.33 2.245-4.341 4.764-.012 2.709 1.926 4.782 4.463 4.773m8.933-1.234v2.17c0 3.206 0 3.206-3.173 2.913-.198-.019-.528.04-.576-.05-1.157-2.208-2.297-.19-3.387.046-3.323.719-6.226.08-8.451-2.536-2.358-2.773-2.982-5.946-1.656-9.381C52.73 9 56.684 6.946 61.395 7.794c3.882.698 6.796 4.243 6.95 8.496.044 1.247.006 2.497.008 3.746"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M120.097 11.732c-2.5.03-4.345 2.109-4.326 4.872.02 2.727 1.954 4.781 4.469 4.747 2.446-.034 4.424-2.24 4.382-4.885-.044-2.684-2.033-4.765-4.525-4.734m4.648 11.861c-3.907 2.44-7.748 2.287-10.648-.366-2.88-2.634-3.652-7.52-1.753-11.09 1.836-3.45 5.951-5.22 10.033-4.312 3.795.843 6.602 4.408 6.662 8.52.036 2.437-.053 4.876.034 7.31.042 1.159-.364 1.576-1.467 1.38-1.107-.196-2.811.834-2.861-1.442M129.666 8.09c1.349 0 2.466.045 3.578-.013.9-.047 1.227.338 1.499 1.167 1.163 3.539 2.427 7.045 3.696 10.685.842-1.088 1.009-2.37 1.415-3.55.533-1.547 1.059-3.095 1.578-4.646 1.33-3.976 1.329-3.977 5.936-3.497-2.677 6.98-5.31 13.942-8.026 20.873-1.023 2.614-3.167 3.768-5.924 3.867-.677.024-1.643.274-1.555-.888.08-1.055-.72-2.414.894-3.048 3.357-1.32 3.953-2.646 2.684-5.944-1.898-4.926-3.793-9.854-5.775-15.005M170.887 16.66c.043-2.75-1.805-4.982-4.185-5.053-2.473-.075-4.484 2.168-4.473 4.988.009 2.552 1.94 4.8 4.209 4.9 2.32.101 4.408-2.168 4.45-4.834m-4.426-8.995c5.04-.033 8.866 3.804 8.862 8.886-.004 4.94-3.847 8.85-8.724 8.877-4.862.027-8.724-3.862-8.77-8.83-.046-4.973 3.75-8.901 8.632-8.933"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(186.8 .215)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M.345 10.192c0-2.495.13-5-.042-7.483C.17.785.636.082 2.738.197c1.617.089 2.11.42 2.068 2.07-.118 4.725-.044 9.454-.04 14.181.002 2.065-.15 4.013 2.802 4.571 1.224.232.352 2.062.464 3.151.09.881-.797.71-1.336.702-3.51-.052-6.053-2.33-6.236-5.821-.154-2.946-.032-5.906-.032-8.86H.345",
  mask: "url(#prefix__b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M177.356 9.773c0-2.628.06-5.258-.027-7.883-.038-1.149.347-1.545 1.456-1.41.457.055.935.064 1.39-.001 1.297-.188 1.689.291 1.667 1.608-.08 4.993-.022 9.987-.037 14.98-.006 1.96.243 3.536 2.692 4.105 1.525.355.497 1.997.663 3.035.155.978-.74.89-1.392.87-3.985-.124-6.246-2.677-6.41-7.222-.006-.13-.002-.262-.002-.394V9.773z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#30D7E5",
  d: "M82.249 12.173c0-2.301.08-4.606-.024-6.902-.096-2.09 1.387-1.451 2.44-1.506 1.026-.054 2.265-.298 2.032 1.47-.236 1.793-.113 3.095 2.434 2.996 1.3-.05.546 1.593.702 2.463.15.839-.369 1.246-1.182 1.121-1.817-.28-2.106.668-1.984 2.169.106 1.306.044 2.628.026 3.943-.021 1.634.493 2.656 2.346 3.055 1.859.4.626 2.08.842 3.157.222 1.107-.737 1.017-1.467.981-3.475-.171-5.955-2.572-6.103-6.045-.098-2.297-.018-4.601-.018-6.902h-.044M70.74 18.56c.187-1.808-.332-3.993.389-6.122 1.102-3.255 4.377-5.224 7.792-4.76 1.435.196 1.024 1.205.961 1.928-.064.746.733 2.097-.9 2.096-2.88 0-4.002 2.04-3.852 4.61.142 2.426-.007 4.868.048 7.302.024 1.044-.206 1.515-1.41 1.537-3.028.053-3.027.119-3.027-2.893V18.56"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M148.649 18.973c.083-1.77-.16-3.81.282-5.837.794-3.627 4.41-6.09 8.044-5.463.557.095.835.238.816.83-.028.855.1 1.729-.034 2.564-.216 1.367-1.384.453-2.081.707-1.807.657-2.6 1.916-2.598 3.759.003 2.7-.05 5.4.025 8.098.032 1.135-.342 1.436-1.466 1.436-2.988 0-2.988.057-2.988-2.867v-3.227z"
})));

var _ref12 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-present",
  viewBox: "0 0 44 44"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 22,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M32.165 15.877h-4.981c.134-.11.269-.218.376-.326 1.347-1.36 1.428-3.456.189-4.68-.565-.572-1.32-.871-2.127-.871-.916 0-1.831.38-2.504 1.06-.35.355-.754.954-1.132 1.634-.35-.708-.78-1.306-1.131-1.633-.673-.68-1.588-1.061-2.504-1.061-.807 0-1.588.3-2.127.87-1.212 1.225-1.131 3.348.188 4.68.108.11.243.219.377.327h-4.981c-.431 0-.808.354-.808.816v5.905c0 .436.35.816.808.816h.134v9.77c0 .435.35.816.807.816h18.5c.43 0 .807-.354.807-.816l.002-9.796h.134c.431 0 .808-.354.808-.816v-5.88c-.027-.434-.404-.815-.835-.815zM21.18 32.34H13.53v-8.952h7.648v8.952zm0-10.558h-8.59V17.51H21.178v4.272zm0-6.205c0 .11-.054.164-.08.219-.027.026-.162.08-.377.08-.97 0-2.532-.815-3.205-1.469-.7-.707-.807-1.795-.188-2.394.242-.245.619-.409.996-.409.484 0 .995.219 1.373.6.781.789 1.4 2.285 1.48 3.102v.271zm1.588-.271c.08-.816.701-2.313 1.481-3.103.377-.38.889-.599 1.374-.599.404 0 .753.136.996.409.592.599.51 1.687-.189 2.394-.673.68-2.235 1.47-3.204 1.47-.216 0-.323-.055-.377-.081-.054-.055-.08-.136-.08-.219v-.271zm7.675 17.034h-7.647v-8.952h7.647v8.952zm.916-10.557h-8.563V17.51h8.589v4.273h-.026z"
})));

var _ref13 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-recommended",
  viewBox: "0 0 37 48"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30D7E5",
  d: "M2 0h32c1.105 0 2 .895 2 2v42.564c0 1.104-.895 2-2 2-.346 0-.687-.09-.988-.261L18 37.776 2.988 46.303c-.96.545-2.182.21-2.727-.751C.09 45.25 0 44.91 0 44.564V2C0 .895.895 0 2 0z",
  transform: "translate(1)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M18 26.5L10.359 30.517 11.818 22.009 5.636 15.983 14.179 14.741 18 7 21.821 14.741 30.364 15.983 24.182 22.009 25.641 30.517z",
  transform: "translate(1)"
})));

var _ref14 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-search",
  viewBox: "0 0 16 16"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#717171",
  fillRule: "evenodd",
  d: "M15.894 14.275l-5.006-5.014c.65-.97 1-2.112 1-3.307 0-1.59-.619-3.086-1.742-4.21C9.024.619 7.531 0 5.944 0 4.356 0 2.864.62 1.74 1.744.618 2.868 0 4.364 0 5.954c0 1.59.618 3.085 1.741 4.21 1.123 1.125 2.615 1.744 4.203 1.744 1.207 0 2.358-.358 3.335-1.023l5 5.009c.169.169.48.132.693-.082l.84-.842c.214-.214.25-.525.082-.694zm-9.95-3.98c-2.39 0-4.334-1.947-4.334-4.341s1.944-4.341 4.334-4.341c2.39 0 4.333 1.947 4.333 4.34 0 2.394-1.943 4.342-4.333 4.342z"
}));

var _ref15 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-tick-blue",
  viewBox: "0 0 22 22"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  fill: "#AFF0F5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M17.953 8.653l-7.426 7.467c-.504.507-1.34.507-1.86 0l-3.705-3.726c-.505-.507-.505-1.348 0-1.871.504-.507 1.34-.507 1.86 0l2.79 2.806 6.496-6.532c.505-.507 1.34-.507 1.861 0 .488.508.488 1.348-.016 1.856z"
})));

var _ref16 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-tick-grey",
  viewBox: "0 0 22 22"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  fill: "#CDCDCD"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M17.953 8.653l-7.426 7.467c-.504.507-1.34.507-1.86 0l-3.705-3.726c-.505-.507-.505-1.348 0-1.871.504-.507 1.34-.507 1.86 0l2.79 2.806 6.496-6.532c.505-.507 1.34-.507 1.861 0 .488.508.488 1.348-.016 1.856z"
})));

var _ref17 = /*#__PURE__*/React.createElement("symbol", {
  id: "ic-tick",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#99CD0F"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M19.585 9.44l-8.1 8.145c-.55.553-1.463.553-2.03 0l-4.042-4.064c-.55-.554-.55-1.47 0-2.042.55-.553 1.462-.553 2.03 0l3.044 3.062 7.086-7.126c.55-.553 1.462-.553 2.03 0 .532.554.532 1.47-.018 2.024z"
})));

var SvgAll = function SvgAll(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAll, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/all.90c060ab.svg";
export { ForwardRef as ReactComponent };